/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Test_RestartInputs */



/**
* | output |
* | --- |
* | "Restart" |
*
* @param {Mesh_Test_RestartInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_test_restart = /** @type {((inputs?: Mesh_Test_RestartInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Test_RestartInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Restart")
	return /** @type {LocalizedString} */ ("Redémarrer")
});